import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=6348d6ef&scoped=true"
import script from "./invoice-detail.vue?vue&type=script&lang=js"
export * from "./invoice-detail.vue?vue&type=script&lang=js"
import style0 from "./invoice-detail.vue?vue&type=style&index=0&id=6348d6ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6348d6ef",
  null
  
)

export default component.exports